import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Moon, ShieldCheck } from 'lucide-react';
export function ObjectionHandlers() {
  return <section className="py-20 px-6 bg-[#1C1C2E] text-[#F5F0E8]" data-id="element-122">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-16 items-center" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8 text-white leading-tight" data-id="element-125">
            Pero… ¿qué pasa con el <br data-id="element-126" />
            <span className="text-[#D4A574] italic" data-id="element-127">"una cosa más"</span>?
          </h2>

          <div className="space-y-8" data-id="element-128">
            <div className="flex gap-4" data-id="element-129">
              <div className="w-12 h-12 rounded-full bg-[#5A8A7A]/10 flex items-center justify-center flex-shrink-0" data-id="element-130">
                <MessageSquare className="w-6 h-6 text-[#5A8A7A]" data-id="element-131" />
              </div>
              <div data-id="element-132">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-133">
                  Guiones Corte + Puente
                </h3>
                <p className="text-[#F5F0E8]/70" data-id="element-134">
                  No te digo "sé paciente". Te doy frases exactas para usar en
                  la cama cuando aparece: agua, pipí, miedo, "no tengo sueño",
                  "quedate". Porque el momento real no te da tiempo para pensar.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-135">
              <div className="w-12 h-12 rounded-full bg-[#5A8A7A]/10 flex items-center justify-center flex-shrink-0" data-id="element-136">
                <ShieldCheck className="w-6 h-6 text-[#5A8A7A]" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-139">
                  Devolver sin show
                </h3>
                <p className="text-[#F5F0E8]/70" data-id="element-140">
                  Y cuando se levanta 10 veces… no lo negociás. No lo sermoneás.
                  Aplicás Devolver sin show: volver a la cama sin discurso, sin
                  show, sin premio. Menos palabras = menos pelea.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-141">
              <div className="w-12 h-12 rounded-full bg-[#5A8A7A]/10 flex items-center justify-center flex-shrink-0" data-id="element-142">
                <Moon className="w-6 h-6 text-[#5A8A7A]" data-id="element-143" />
              </div>
              <div data-id="element-144">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-145">
                  Puente Nocturno
                </h3>
                <p className="text-[#F5F0E8]/70" data-id="element-146">
                  Para los despertares de madrugada: un protocolo de 1–3 minutos
                  para que el despertar no se convierta en una segunda rutina.
                  Si a las 2:00 AM hay charla y luz, el cerebro aprende a
                  despertarse más.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative" data-id="element-147">
          <div className="absolute inset-0 bg-[#D4A574] blur-[80px] opacity-10 rounded-full" data-id="element-148" />
          <div className="relative bg-[#14142B] p-8 rounded-2xl border border-[#D4A574]/20 shadow-2xl" data-id="element-149">
            <h3 className="text-lg font-serif text-[#D4A574] mb-6 text-center" data-id="element-150">
              Ejemplo de Tarjeta Recortable
            </h3>

            <div className="bg-[#F5F0E8] text-[#1C1C2E] p-6 rounded-lg shadow-inner transform rotate-1" data-id="element-151">
              <div className="border-b-2 border-[#1C1C2E]/10 pb-4 mb-4" data-id="element-152">
                <p className="text-xs font-bold uppercase tracking-wider text-[#5A8A7A]" data-id="element-153">
                  Situación: Pide Agua
                </p>
              </div>
              <p className="font-serif text-xl italic mb-4" data-id="element-154">
                "Acá está el agua. Un trago y a dormir. Mañana seguimos."
              </p>
              <div className="bg-[#1C1C2E]/5 p-3 rounded text-sm font-medium" data-id="element-155">
                <span className="block font-bold mb-1" data-id="element-156">Acción:</span>
                Entregar vaso sin prender luz. No preguntar "¿está rica?".
                Retirar vaso. Salir.
              </div>
            </div>

            <div className="mt-6 text-center" data-id="element-157">
              <p className="text-sm text-[#F5F0E8]/50" data-id="element-158">
                Incluido en el pack de tarjetas imprimibles
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}